/* SPH – Filterwerte numerisch sortieren + Finder-Teaser */
(function () {
  function num(text) {
    var m = (text || '').replace(/\s/g, '').match(/(\d+(?:[.,]\d+)?)/);
    return m ? parseFloat(m[1].replace(',', '.')) : NaN;
  }

  function sortPanel(panel) {
    var opts = Array.prototype.slice.call(panel.querySelectorAll('.sph-fopt'));
    if (opts.length < 2) return;
    var values = opts.map(function (o) { return num(o.textContent); });
    var numeric = values.filter(function (v) { return !isNaN(v); }).length;
    if (numeric < opts.length) return;
    opts.sort(function (a, b) {
      var d = num(a.textContent) - num(b.textContent);
      if (d !== 0) return d;
      return a.textContent.localeCompare(b.textContent, 'de');
    });
    opts.forEach(function (o) { panel.appendChild(o); });
  }

  function banner() {
    var coll = document.querySelector('[data-sph-coll]');
    if (!coll || coll.querySelector('.sph-findban')) return;
    var fbar = coll.querySelector('.sph-fbar');
    if (!fbar) return;
    var a = document.createElement('a');
    a.className = 'sph sph-findban';
    a.href = '/pages/stegplatten-finder';
    a.innerHTML =
      '<span class="sph-findban__ic"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 15l12-12 6 6-12 12H3v-6z"/><path d="M7 15h4"/></svg></span>' +
      '<span class="sph-findban__b"><strong>Nicht sicher, welche Platte passt?</strong><em>Drei kurze Fragen \u2014 und Sie sehen genau die Platten, die zu Ihrem Projekt passen.</em></span>' +
      '<span class="sph-findban__cta">Finder starten <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></span>';
    fbar.insertAdjacentElement('afterend', a);
  }

  function run() {
    document.querySelectorAll('.sph-fdd__p').forEach(sortPanel);
    banner();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
